import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Pager from './Paging';
import authService from './api-authorization/AuthorizeService';

interface Result {
    pageSize: number;
    totalRecords: number;
    searchResults: UserList[];
}

interface UserList {
    id: number;
    name: string;
    email: string;
    status: string;
}

const UserSearchData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [showInactive, setShowInactive] = React.useState(false);
    const [showResults, setShowResults] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [result, setResult] = React.useState<Result>({
        pageSize: 1,
        totalRecords: 0,
        searchResults: []
    });

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async() => {
        const user = await authService.getUser();
        const token = await authService.getAccessToken();
        axios.get('Users/CheckUserPermission?SubId=' + user.sub + '&Permission=CreateEditUsers', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data === true) {
                setLoading(false);
            } else {
                //redirect to 403 permission denied
                navigate("/accessdenied");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const addNew = () => {
        navigate("/user");
    }

    const reset = () => {
        setName("");
        setEmail("");
        setShowInactive(false);
        setPage(1);
        setResult({
            pageSize: 1,
            totalRecords: 0,
            searchResults: []
        });
        setShowResults(false);
    }

    const search = (e: any) => {
        e.preventDefault();

        //check to make sure at least one search field has been entered
        if (name || email) {
            getUsers(1, true);
        } else {
            setShowResults(false);
            toast.error("Please enter at least one search item");
        }

    }

    const getUsers = async(page: number, getTotalRecords: boolean) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        var totalRecords = getTotalRecords ? 0 : result.totalRecords;

        var searchName = name ? name : "";
        var searchEmail = email ? email : "";

        axios.get('Users/SearchUsers?subId=' + user.sub + '&Name=' + searchName + '&Email=' + searchEmail + '&ShowInactive=' + showInactive + '&page=' + page + '&totalRecords=' + totalRecords + '&getTotalRecords=' + getTotalRecords, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setShowResults(true);
            setResult(res.data);
        })
    }

    const pageChanged = (pageNumber: number) => {
        setPage(pageNumber);

        getUsers(pageNumber, false);
    }

    var pagerContents;
    if ((result.totalRecords / result.pageSize) > 1) {
        //only render if we have records
        pagerContents = <Pager page={page} pageSize={result.pageSize} totalRecords={result.totalRecords} pageChanged={pageChanged} />
    }

    const renderDetails = (
        <form onSubmit={search}>
            <div>
                <div className="input-group-parent3">
                    <label className="input-group" htmlFor="name">
                        <span className="label-small">Name</span>
                        <input className="input" type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)}></input>
                    </label>
                </div>
                <div className="input-group-parent3">
                    <label className="input-group" htmlFor="email">
                        <span className="label-small">Email</span>
                        <input className="input" type="text" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}></input>
                    </label> 
                </div>
                <div className="input-group-parent3">
                    <label className="input-group" htmlFor="inactive">
                        <span className="label-small">Show Inactive</span>
                        <input className="input checkbox" type="checkbox" id="inactive" name="showInactive" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)}></input>
                    </label>
                </div>
                <div>
                    <button className="defaultbutton-prev defaultbutton-prev__split3" type='submit'>Search</button>
                    <button className="defaultbutton-next" type='button' onClick={reset}>Reset</button>
                </div>
                <hr></hr>
            
                <div className={showResults ? 'overflowAuto' : 'hidden'}>
                    <table className="table--main tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {result.searchResults.map(user =>
                                <tr key={user.id}>
                                    <td className="hidden">{user.id}</td>
                                    <td><NavLink to={'/user/' + user.id}>{user.name}</NavLink></td>
                                    <td>{user.email}</td>
                                    <td>{user.status}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {pagerContents}
            </div>

        </form>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <div className="input-group-parent marginBottom10">
                <h1>User Search</h1>
            </div>
            <div className="input-group-parent marginBottom10">
                <div className="defaultbutton__container--right">
                    <button className="defaultbutton defaultbutton__small" type='button' onClick={addNew}>Add New</button>
                </div>
            </div>
            {contents}
        </div>
    );
}

export default UserSearchData;